

(function (window) {
  'use strict';


  const SECRET_KEY =
    '0de76f9574e8f05c1ccd9a6b6670e358f1e6955e9d29a7ec8bbc62edf4b3e0b4';
  const API_ENDPOINT =
    'https://i-shopify-app.realsee.ai/api/auth/realsee-token';


  async function hmacSHA256(message, secret) {
    const encoder = new TextEncoder();
    const keyData = encoder.encode(secret);
    const messageData = encoder.encode(message);

    const key = await crypto.subtle.importKey(
      'raw',
      keyData,
      { name: 'HMAC', hash: 'SHA-256' },
      false,
      ['sign']
    );

    const signature = await crypto.subtle.sign('HMAC', key, messageData);


    return Array.from(new Uint8Array(signature))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
  }


  function generateNonce() {
    return (
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15)
    );
  }


  async function generateAuthHeaders() {
    const timestamp = Date.now().toString();
    const nonce = generateNonce();


    const signature = await hmacSHA256(timestamp + nonce, SECRET_KEY);

    return {
      'X-Timestamp': timestamp,
      'X-Nonce': nonce,
      'X-Signature': signature
    };
  }


  async function getRealseeToken() {
    try {
      const headers = await generateAuthHeaders();

      const response = await fetch(API_ENDPOINT, {
        method: 'GET',
        headers: headers,
        credentials: 'include'
      });

      if (!response.ok) {
        throw new Error('Failed to fetch Realsee token: ' + response.status);
      }

      const data = await response.json();

      if (data.code === 0 && data.data && data.data.access_token) {
        return {
          access_token: data.data.access_token,
          expire_at: data.data.expire_at,
          trace_id: data.trace_id || ''
        };
      } else {
        throw new Error(
          'Invalid token response: ' + (data.status || 'Unknown error')
        );
      }
    } catch (error) {
      console.error('Error getting Realsee token:', error);
      throw error;
    }
  }


  const TokenCache = {
    token: null,
    traceId: '',
    expireAt: 0,


    async getToken() {
      const now = Date.now();


      if (this.token && now < this.expireAt - 300000) {
        return this.token;
      }


      const tokenData = await getRealseeToken();
      this.token = tokenData.access_token;
      this.traceId = tokenData.trace_id || '';
      this.expireAt = tokenData.expire_at;

      return this.token;
    },


    async getTraceId() {
      const now = Date.now();

      if (this.token && now < this.expireAt - 300000) {
        return this.traceId;
      }

      await this.getToken();
      return this.traceId;
    },


    clear() {
      this.token = null;
      this.traceId = '';
      this.expireAt = 0;
    }
  };


  window.RealseeAuth = {
    getToken: function () {
      return TokenCache.getToken();
    },
    getTraceId: function () {
      return TokenCache.getTraceId();
    },
    clearToken: function () {
      TokenCache.clear();
    },
    getAuthHeaders: function () {
      return generateAuthHeaders();
    }
  };
})(window);
